import IconButton from '@mui/material/IconButton';
import React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { MdOutlineFileDownload } from 'react-icons/md';
import { toast } from 'react-toastify';

import api from '../../services/apiSgft';
import LightTooltip from '../atoms/LightTooltip';

interface JobTitleDownloadButtonProps {
	searchTerm: string;
	filteredData: {
		seniorityLevels: string[];
		companies: string[];
		boards: string[];
		managements: string[];
		workStations: string[];
		// requirementTypes: string[];
		// educationalRequirements: string[];
		// professionalRequirements: string[];
		// otherRequirements: string[];
	};
}

export const JobTitleDownloadButton = ({
	searchTerm,
	filteredData,
}: JobTitleDownloadButtonProps) => {
	const [loading, setLoading] = React.useState(false);

	async function download() {
		setLoading(true);
		try {
			const response = await api.get(`/extraction/job-title`, {
				params: {
					title: searchTerm,
					seniorityLevels: filteredData?.seniorityLevels,
					companies: filteredData?.companies,
					boards: filteredData?.boards,
					managements: filteredData?.managements,
					workStations: filteredData?.workStations,
					// requirementType: filteredData?.requirementTypes,
					// educationalRequirements: filteredData?.educationalRequirements,
					// professionalRequirements: filteredData?.professionalRequirements,
					// otherRequirements: filteredData?.otherRequirements,
				},
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				}),
			);
			const link = document.createElement('a');

			link.href = url;
			link.setAttribute('download', 'Cargos.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e) {
			toast.error('Estrutura sem dados', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer">
			<LightTooltip title="Extrair cargos">
				<IconButton onClick={download} disabled={loading}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<MdOutlineFileDownload />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);
};
